// Modal Backdrop
.backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;

  [data-theme='dark'] & {
    background: rgba(0, 0, 0, 0.7);
  }
}

// Generate More Modal Content
.modal {
  display: flex;
  flex-direction: column;
  min-height: 500px;
}

// Search Section
.search {
  display: flex;
  align-items: stretch;
  gap: map.get($spacing-scale, 'md');
  padding: map.get($spacing-scale, 'lg');
  border-bottom: 1px solid var(--color-border);
}

.typeAheadWrapper {
  flex: 1;
  min-width: 0;
}

// Results Area
.results {
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: map.get($spacing-scale, 'lg');
  overflow: hidden;
}

// Empty State
.empty {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px map.get($spacing-scale, 'lg');
  gap: map.get($spacing-scale, 'md');
}

.emptyText {
  @include body-regular;
  color: var(--color-text-secondary);
  margin: 0;
}

// Table Styles
.table {
  display: flex;
  flex-direction: column;
  border: 1px solid var(--color-border);
  border-radius: map.get($radius, 'md');
}

.tableHeader {
  display: flex;
  align-items: center;
  background: var(--color-surface-alt);
  border-bottom: 1px solid var(--color-border);
  border-radius: map.get($radius, 'md') map.get($radius, 'md') 0 0;
}

.tableBody {
  display: flex;
  flex-direction: column;
  max-height: 350px;
  overflow-y: auto;
  border-radius: 0 0 map.get($radius, 'md') map.get($radius, 'md');
}

.tableRow {
  display: flex;
  align-items: center;
  border-bottom: 1px solid var(--color-border);

  &:last-child {
    border-bottom: none;
  }

  &:hover {
    background: var(--color-surface-alt);
  }
}

.tableCell {
  padding: map.get($spacing-scale, 'sm') map.get($spacing-scale, 'md');
  @include body-small-regular;
  color: var(--color-text-primary);
  display: flex;
  align-items: center;

  .tableHeader & {
    @include body-small-medium;
    color: var(--color-text-secondary);
    padding: map.get($spacing-scale, 'sm') map.get($spacing-scale, 'md');
  }
}

// Column widths - matching Figma layout
.cellId {
  width: 80px;
  flex-shrink: 0;
}

.cellName {
  flex: 1;
  min-width: 180px;
}

.cellType {
  width: 110px;
  flex-shrink: 0;
}

.cellLeads {
  width: 150px;
  flex-shrink: 0;
  justify-content: flex-start;
}

.cellActions {
  width: 40px;
  flex-shrink: 0;
  justify-content: center;
}

// Remove button - shows on row hover
.removeButton {
  opacity: 0;
  @include transition(opacity);

  .tableRow:hover & {
    opacity: 1;
  }

  &:focus-visible {
    opacity: 1;
  }
}

// Responsive adjustments
@media (max-width: $breakpoint-md) {
  .search {
    flex-direction: column;
  }

  .table {
    font-size: 12px;
  }

  .cellId {
    width: 60px;
  }

  .cellType {
    display: none;
  }

  .cellLeads {
    width: 120px;
  }
}
